import {BrowserAgent} from '@newrelic/browser-agent/loaders/browser-agent';

if (process.env.REACT_APP_ENV !== 'local') {
  const options = {
    init: {
      distributed_tracing: {enabled: true},
      privacy: {cookies_enabled: true},
      ajax: {deny_list: ['bam.nr-data.net']},
    },
    info: {
      beacon: 'bam.nr-data.net',
      errorBeacon: 'bam.nr-data.net',
      licenseKey: process.env.REACT_APP_NEWRELIC_LICENSE_KEY,
      applicationID: process.env.REACT_APP_NEWRELIC_APPLICATION_ID,
      sa: 1},
    loader_config: {
      accountID: process.env.REACT_APP_NEWRELIC_ACCOUNT_ID,
      trustKey: process.env.REACT_APP_NEWRELIC_TRUST_KEY,
      agentID: process.env.REACT_APP_NEWRELIC_AGENT_ID,
      licenseKey: process.env.REACT_APP_NEWRELIC_LICENSE_KEY,
      applicationID: process.env.REACT_APP_NEWRELIC_APPLICATION_ID,
    },
  };

  new BrowserAgent(options);
}
